import React from "react";
import CompanyInformation from "./companyinformation/CompanyInformation";
import Breadcrumb from "../../../components/common/BreadCrumb";
import Tab from "../../../components/common/Tab";
import Outlet from "./companyinformation/Outlet";
import Equipments from "./companyinformation/Equipments";
import Staff from "./companyinformation/Staff";
import Document from "./companyinformation/Document";

const CreateEditCompany = () => {
  const storedData = sessionStorage.getItem("companyData");
  const companyData = storedData ? JSON.parse(storedData)?.company : null;

  const tabs = [
    {
      label: "General Information",
      content: <CompanyInformation companyData={companyData} />,
    },
    {
      label: "Staff",
      content: <Staff companyData={companyData} />,
    },
    {
      label: "Equipments",
      content: <Equipments companyData={companyData} />,
    },
    {
      label: "Outlet",
      content: <Outlet companyData={companyData} />,
    },
    {
      label: "Document",
      content: <Document companyData={companyData} />,
    },
  ];

  return (
    <div className="space-y-5">
      <div>
        <h6 className="font-Montserrat font-medium text-2xl mb-3">
          Company & Outlets
        </h6>
        <Breadcrumb
          breadCrumbParent={"Home"}
          breadCrumbActive={companyData?.name}
          breadCrumbParent2={"Company & Outlets"}
          breadCrumbTitleKey={"/"}
          classes=""
        />
      </div>
      <Tab
        tabs={tabs}
        companyData={companyData}
        company={"true"}
        btnClass="w-full font-normal  mb-5 h-full"
        btnDivClass="bg-white rounded-xl px-2 pt-4 py-2 my-4 "
      />
    </div>
  );
};

export default CreateEditCompany;
